import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "react-use-cart";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import RequestBook from "./pages/RequestBook";
import TransactionHistory from "./pages/TransactionHistory";
import Invoice from "./pages/Invoice";
import ScrollToTop from "./helpers/ScrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CartProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<App />}>
              <Route index element={<Products />} />
              <Route path="/product" element={<ProductDetail />} />
              <Route path="/transaction-history" element={<TransactionHistory />} />
              <Route path="/request-book" element={<RequestBook />} />
              <Route path="/success" element={<Invoice />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </CartProvider>
  </React.StrictMode>
);

reportWebVitals();
